module.exports = __webpack_public_path__ + "img/vessel_visitation_12_63021.8ae41639.jpg";